/**
 * Push an event to the GTM dataLayer.
 * Safe to call even if GTM hasn't loaded yet — dataLayer is initialised first.
 */
export function pushDataLayer(data) {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(data);
}
